import { MdKeyboardArrowRight } from "react-icons/md";
import { Container } from "react-bootstrap";

export default function BreadcrumbBar({ items = [] }) {
  return (
    <div className="breadcrumb-bar">
      <Container>
        <nav className="custom-breadcrumb">
          {items.map((item, i) => (
            <span key={i} className="crumb">
              {item.href ? (
                <a href={item.href}>{item.label}</a>
              ) : (
                <span className="active">{item.label}</span>
              )}
              {i < items.length - 1 && (
                <MdKeyboardArrowRight className="crumb-sep" />
              )}
            </span>
          ))}
        </nav>
      </Container>
    </div>
  );
}
